import * as React from 'react';
import { useAuthStore } from '@/auth';
import { Auth } from 'firebase/auth';
import { isRight, isLeft } from '@shared-commons/utils';
import { useSubscriptionStore } from '../store/subscription-store';
import { getSubscriptions } from '../services/get-subscriptions';

export const useSubscription = (auth: Auth) => {
  const {
    customerSubscription,
    subscriptionsOptions,
    setSubscriptionsOptions,
    setSubscriptionsLoading,
    subscriptionsLoading,
  } = useSubscriptionStore();
  const { user } = useAuthStore();
  const [error, setError] = React.useState<Error | null>(null);

  const getSubs = React.useCallback(async () => {
    const result = await getSubscriptions()();
    if (isRight(result)) {
      setSubscriptionsOptions(result.value);
      setSubscriptionsLoading(false);
    } else if (isLeft(result)) {
      const error = new Error(result.value?.message || 'Errore durante il recupero del profilo');
      setError(error);
      setSubscriptionsLoading(false);
    }
  }, [setSubscriptionsOptions, setSubscriptionsLoading, auth]);

  return {
    subscriptionsLoading,
    error,
    customerSubscription,
    subscriptionsOptions,
    getSubs,
  };
};
